import { jsx, jsxs } from "react/jsx-runtime";
import { Label, RadioGroup, XStack, YStack } from "tamagui";
function RadioGroupDemo() {
  return /* @__PURE__ */ jsx(RadioGroup, { defaultValue: "3", name: "form", children: /* @__PURE__ */ jsxs(YStack, { width: 300, alignItems: "center", space: "$2", children: [
    /* @__PURE__ */ jsx(RadioGroupItemWithLabel, { size: "$3", value: "2", label: "Second value" }),
    /* @__PURE__ */ jsx(RadioGroupItemWithLabel, { size: "$4", value: "3", label: "Third value" }),
    /* @__PURE__ */ jsx(RadioGroupItemWithLabel, { size: "$5", value: "4", label: "Fourth value" })
  ] }) });
}
function RadioGroupItemWithLabel(props) {
  const id = `radiogroup-${props.value}`;
  return /* @__PURE__ */ jsxs(XStack, { width: 300, alignItems: "center", space: "$4", children: [
    /* @__PURE__ */ jsx(RadioGroup.Item, { value: props.value, id, size: props.size, children: /* @__PURE__ */ jsx(RadioGroup.Indicator, {}) }),
    /* @__PURE__ */ jsx(Label, { size: props.size, htmlFor: id, children: props.label })
  ] });
}
export {
  RadioGroupDemo,
  RadioGroupItemWithLabel
};
//# sourceMappingURL=RadioGroupDemo.js.map
